var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.853 7.85399L8.853 14.854C8.75911 14.9479 8.63177 15.0006 8.499 15.0006C8.36622 15.0006 8.23889 14.9479 8.145 14.854C8.05111 14.7601 7.99837 14.6328 7.99837 14.5C7.99837 14.3672 8.05111 14.2399 8.145 14.146L14.293 7.99999H0.5C0.367392 7.99999 0.240215 7.94731 0.146447 7.85354C0.0526785 7.75978 0 7.6326 0 7.49999C0 7.36738 0.0526785 7.2402 0.146447 7.14644C0.240215 7.05267 0.367392 6.99999 0.5 6.99999H14.293L8.146 0.853991C8.05211 0.760104 7.99937 0.632766 7.99937 0.499991C7.99937 0.367215 8.05211 0.239877 8.146 0.145991C8.23989 0.052104 8.36722 -0.000640868 8.5 -0.000640869C8.63278 -0.00064087 8.76011 0.052104 8.854 0.145991L15.854 7.14599C15.9006 7.19244 15.9375 7.24761 15.9627 7.30836C15.9879 7.3691 16.0009 7.43422 16.0009 7.49999C16.0009 7.56576 15.9879 7.63088 15.9627 7.69162C15.9375 7.75237 15.9006 7.80754 15.854 7.85399H15.853Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.602c38d22908dd5018c5d1180b1a6166.svg";
export { ForwardRef as ReactComponent };